import Choices from 'choices.js'

window.choices = {
	choices: null,

	rebuild: function() {
		const choicesElements = document.querySelectorAll('.l-event-filter select:not(.choices__input)');

		if (!choicesElements[0]) {
			return
		}

		for (let i = 0; i < choicesElements.length; i++) {
			const element = choicesElements[i];

			const choices = new window.choices.choices(element, {
				shouldSort      : false,
				removeItemButton: true,
				itemSelectText  : 'auswählen'
			});

			element.addEventListener('change', function(e) {
				const filter = e.target.closest('.m-event-filter__select');
				const label = filter.querySelectorAll('label');
				label[0].classList.add('active')

				if (e.target.value === '') {
					let placeholder = choices._presetItems[0]
					choices.setChoiceByValue(placeholder)

					const filter = e.target.closest('.m-event-filter__select');
					const label = filter.querySelectorAll('label');

					label[0].classList.remove('active')
				}
			}, false);
		}
	}
}

window.choices.choices = Choices;
window.choices.rebuild();
